export const PROJECTS_MONTHLY_FEE = 29;
export const PROJECTS_MONTHLY_CODE = 'PROJECTS_MONTHLY';
export const PROJECTS_MONTHLY_DESCRIPTION = 'Uptimio Projects — monthly';

export const companyBillsProjectsModule = (company?: {
  isOwner?: boolean;
  modules?: { projects?: boolean };
} | null): boolean => Boolean(company && !company.isOwner && company.modules?.projects);

export const isProjectsMonthlyItem = (item?: { code?: string; description?: string } | null): boolean =>
  Boolean(
    item &&
    (item.code === PROJECTS_MONTHLY_CODE || item.description === PROJECTS_MONTHLY_DESCRIPTION)
  );

export const projectsMonthlyItem = () => ({
  code: PROJECTS_MONTHLY_CODE,
  description: PROJECTS_MONTHLY_DESCRIPTION,
  quantity: 1,
  unitPrice: PROJECTS_MONTHLY_FEE
});
